import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevrons-up-left', 'ChevronsUpLeft', [["path",{"d":"M7 15v-8h8","key":"svg-0"}],["path",{"d":"M11 19v-8h8","key":"svg-1"}]]);